module.exports = __webpack_public_path__ + "images/bus.4e19a56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hoverProducts/bus.png
// module id = rWmf
// module chunks = 19